"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabButton = function TabButton(_ref) {
  var value = _ref.value,
      label = _ref.label,
      hasTabPanel = _ref.hasTabPanel,
      handleClick = _ref.handleClick,
      isSelected = _ref.isSelected,
      fullWidth = _ref.fullWidth;
  var tabClass = (0, _dedupe.default)('tab', {
    'tab--selected': isSelected,
    'tab--fullWidth': fullWidth
  });
  return _react.default.createElement("button", {
    id: "".concat(value, "-tab"),
    className: tabClass,
    role: "tab",
    "aria-selected": isSelected,
    "aria-controls": hasTabPanel && isSelected ? "".concat(value, "-panel") : null,
    tabIndex: -1,
    onClick: function onClick(e) {
      return handleClick(e, value);
    }
  }, label);
};

exports.TabButton = TabButton;
TabButton.defaultProps = {
  hasTabPanel: false,
  handleClick: function handleClick() {},
  isSelected: false,
  fullWidth: false
};
TabButton.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  label: _propTypes.default.string.isRequired,
  hasTabPanel: _propTypes.default.bool,
  // The following values provided by the parent (TabList or ScrollableTabList)
  handleClick: _propTypes.default.func,
  isSelected: _propTypes.default.bool,
  fullWidth: _propTypes.default.bool
};